// Campus photo for /colleges/chapman-university: CC BY 3.0, by Bobak Ha'Eri, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3A2008-0614-LA-OC-005-Chapman.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/chapman-university/; credited under the photo.
const photo = {
    "slug": "chapman-university",
    "alt": "A building on the Chapman University campus in Orange, California",
    "src": "/colleges/chapman-university/campus-1600.webp",
    "srcSmall": "/colleges/chapman-university/campus-800.webp",
    "srcMid": "/colleges/chapman-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/chapman-university/og.jpg",
    "title": "2008-0614-LA-OC-005-Chapman",
    "author": "Bobak Ha'Eri",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3A2008-0614-LA-OC-005-Chapman.jpg",
    "read": "2026-10-01"
};

export default photo;
